// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"c837374a","338":"8a0c9795","484":"1bef058b","629":"a6fc9f5f","645":"c6ff57e1","672":"8c930295","842":"8df647c5","869":"d1c6690c","883":"156048ae","974":"2be7b50c"}[chunkId] + ".chunk.js";
};